 import React, { useEffect, useState } from "react";
  import Meta from "../components/Meta";
 import 'react-medium-image-zoom/dist/styles.css'
  import { Link, useLocation, useNavigate } from "react-router-dom";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import {  getAProduct,   getRelatedProducts } from "../features/products/productSlice";
 import { IoSettings } from "react-icons/io5";  
import { RiBuilding2Fill } from "react-icons/ri";
import "../styles/singlepage.css";
  import BackToTop from "../components/BackToTop";
  import RelatedProducts from "../components/RelatedProducts";
 import BreadCrumb3 from "../components/BreadCrumb3";
 import { useMediaQuery } from "react-responsive";
import RelatedProducts2 from "../components/RelatedProducts2";
import { FaCar } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import loader from "../images/loader/loader1.jpg"
 import { FaLocationDot } from "react-icons/fa6";
 import { toast } from "react-toastify"; 
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
 import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "../styles/customGallery.css"
import SalesPersonCard from "../components/SalespersonCard";
import {  FaFacebookF, FaLink } from "react-icons/fa";
 import { FaXTwitter } from "react-icons/fa6";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";


const SingleProduct = () => {
       
  
  const location = useLocation();
   const getProductSlug = location.pathname.split("/")[2]
  const dispatch = useDispatch();
  const productState = useSelector(state => state?.product?.singleproduct);
    const isDesktop = useMediaQuery({ minWidth: 768 });

  const relatedProducts = useSelector((state) => state.product.relatedProducts);

 
  useEffect(() => {
    if (!productState) {
      dispatch(getAProduct(getProductSlug));
      dispatch(getRelatedProducts(getProductSlug));
    }
  }, [dispatch, getProductSlug, productState]);
  
 
   const [activeFilter, setActiveFilter] = useState("vdetails");
  
 
 
 
   const copyToClipboard = (text) => {
    console.log("Copied Text:", text);
    const textField = document.createElement("textarea");
    textField.value = text;  
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
    toast.info("Vehicle link copied to clipboard!");  
  };
 
  
 const galleryImages = productState?.images?.length
  ? productState.images.map((image) => ({
      src: image.url,
      width: 4,   // you can set dynamic ratios later
      height: 3,
    }))
  : [{ src: loader, width: 4, height: 3 }];


   const [loading, setLoading] = useState(true);

   useEffect(() => {
    if (productState?.description) {
      setLoading(false);
    }
  }, [productState?.description]);

 const productSpecs = [
  { label: "Engine", value: productState?.engineSize[0]?.title || "N/A" },
  { label: "Fuel", value: productState?.fuelType || "N/A" },
  { label: "Transmission", value: productState?.transmission || "N/A" },
  { label: "Drive", value: productState?.drive || "N/A" },
  { label: "Seats", value: productState?.seats || "N/A" },
  { label: "No. of Seats", value: productState?.seatsNumber || "N/A" },
  { label: "Engine Detail", value: productState?.engineDetail || "N/A" },
  { label: "Torque", value: productState?.torque || "N/A" },
  { label: "Zero to Hundred", value: productState?.acceleration ? `${productState.acceleration} seconds` : "N/A" },
  { label: "Drivetrain", value: productState?.driveTrain || "N/A" },
  { label: "Horsepower", value: productState?.horsePower ? `${productState.horsePower} hp` : "N/A" },
  { label: "Rear Seats", value: productState?.rearSeats || "N/A" },
  { label: "Upholstery", value: productState?.upholstery || "N/A" },
  { label: "Cargo Space", value: productState?.cargoSpace || "N/A" },
  { label: "Front Seats", value: productState?.frontSeats || "N/A" },
   { label: "Transmission Detail", value: productState?.transmission || "N/A" },  
   { label: "Steering Wheel", value: productState?.steeringWheel || "N/A" },
  { label: "Climate Control", value: productState?.climateControl || "N/A" },
  { label: "Fuel Efficiency", value: productState?.fuelEfficiency || "N/A" },
  { label: "Towing Capacity", value: productState?.towingCapacity || "N/A" },
  { label: "Ground Clearance", value: productState?.groundClearance || "N/A" },
  { label: "Interior Lighting", value: productState?.interiorLighting || "N/A" },
];

  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const mainImage = galleryImages[0];
  const sideImages = galleryImages.slice(1, 5); // next 4 only
  const remaining = galleryImages.length - 5;
 
 
  useEffect(() => {
    let loaded = 0;
    const total = 1 + sideImages.length;
    const all = [mainImage, ...sideImages];

    all.forEach((img) => {
      const image = new Image();
      image.src = img.src;
      image.onload = () => {
        loaded++;
        if (loaded === total) setLoading(false);
      };
    });
  }, [mainImage, sideImages]);

const handleEnquirySubmit = (e) => {
  e.preventDefault();
  const formData = new FormData(e.target);

  const enquiryData = {
    name: formData.get("name"),
    email: formData.get("email"),
    phone: formData.get("phone"),
    contactMethod: formData.get("contactMethod"),
    additionalInfo: formData.get("additionalInfo"),
    vehicleId: productState?._id,
  };

  console.log("Enquiry Submitted:", enquiryData);
  // TODO: send this to backend API
  alert("Thank you! Your enquiry has been submitted.");
};



  return (
    <>
      <Meta title={productState?.title} />
   
      <BreadCrumb3 title={productState?.title} />

   
      <BackToTop />
      <Container class1="card-wrapper   home-wrapper-2 ">

      <div className="cart-row ">
      <div className="col-12 ">
          
      <section className="section-c ">
      <Container class1="main-product-wrapper bg-white  mb-3 home-wrapper-2">
   
          <div className=" single-product">
            <div className="col-12">
    <div className={`col-6 pr-image ${isDesktop ? "ls-pr-image" : "pr-image-2"}`}>
    <div className="custom-gallery">
      {/* Main Image */}
      <div
        className="main-image"
        onClick={() => setOpen(true)}
      >
        <LazyLoadImage
          alt="Main"
          effect="blur"
          src={mainImage?.src || loader}
          placeholderSrc={loader}
          width="100%"
          height="100%"
          className="img-fluid mx-auto img-el"
          style={{
            objectFit: "cover",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        />
      </div>

      {/* Side Thumbnails */}
      <div className="side-images">
        {sideImages.map((img, i) => (
          <div
            key={i}
            className="thumb"
            onClick={() => {
              setOpen(true);
              setIndex(i + 1);
            }}
          >
            <LazyLoadImage
              alt={`thumb-${i}`}
              effect="blur"
              src={img?.src || loader}
              placeholderSrc={loader}
              width="100%"
              height="100%"
              className="img-fluid"
              style={{
                objectFit: "cover",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "transform 0.3s ease",
              }}
            />

            {i === sideImages.length - 1 && remaining > 0 && (
              <div className="overlay__container">
                <div className="overlay">+{remaining} Photos</div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Lightbox */}
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={galleryImages.map((img) => ({ src: img.src }))}
        index={index}
        plugins={[Thumbnails]}
      />
    </div>
    </div>

       
       
   
            </div>
 
        </div>
       
        </Container>
        
      
         <div className="vehicle__info-wrapper">

          <div className="vehicle__info-left-col">
          <div className={`col-6 prod-details ${isDesktop? "ls-prod-details" : "prod-details-2"}`}>
            <div className="main-product-details">
              <div className="border-bottom">
              {loading? (
                  <Skeleton  width="30%" height="20px" />
                ):(
                <h3 className="title">
                  
                  {productState?.title}
                </h3>)}
              </div>
              <div className="border-bottom py-3">
                {loading? (
                  <Skeleton width="25%" height="20px" style={{ marginBottom: '10px' }} />
                ):(
                  <p className="price">KES {productState?.price.toLocaleString()}</p>         

                )}
              </div>

              <div className=" py-3">
                {isDesktop? (
            <div className="product-description-el">
            {loading ? (
             
              
              <Skeleton count={5} width="100%" height="20px" />
         
            ) : (
               
 
              <p dangerouslySetInnerHTML={{ __html: productState?.description }}></p>
              
            )}
          </div>
                ) : (
                  <p dangerouslySetInnerHTML={{ __html: productState?.description }}></p>

                )}
 

                  
               <div className="car-details">
                 <div className="s-location"><FaLocationDot /> {productState?.location}</div>
                <div className="yom"><FaCar /> model-{productState?.yom}</div>
                <div className="transmission"><IoSettings /> Automatic{productState?.transmisson}</div>
                <div className="car-brand"><RiBuilding2Fill /> {productState?.brand}</div>
               </div>
            
 <div className="vehicle-share">
  <h4>Share this vehicle</h4>
  <div className="vehicle-social-icons">
    {/* WhatsApp */}
    <a
      href={`https://wa.me/?text=Check%20out%20this%20vehicle:%20${window.location.href}`}
      target="_blank"
      rel="noopener noreferrer"
      className="social-btn whatsapp"
    >
      <FaWhatsapp />
    </a>

    {/* Facebook */}
    <a
      href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
      target="_blank"
      rel="noopener noreferrer"
      className="social-btn facebook"
    >
      <FaFacebookF />
    </a>

    {/* X (Twitter) */}
    <a
      href={`https://twitter.com/intent/tweet?url=${window.location.href}&text=Check%20out%20this%20vehicle`}
      target="_blank"
      rel="noopener noreferrer"
      className="social-btn twitter"
    >
      <FaXTwitter />
    </a>

    {/* Copy Link */}
    <button
      onClick={() => copyToClipboard(window.location.href)}
      className="social-btn copy"
    >
      <FaLink />
    </button>
  </div>
</div>

     
              </div>
               {!isDesktop && (
  <div className="vehicle__info-right-col vehicle__info-right-col-media w-100 position-relative">
    {productState?.stock !== "Out of Stock" ? (
      <>
        <SalesPersonCard />
      </>
    ) : (
      <div className="stock-container">
        <button className="button border-0 out-of-stock-btn" disabled>
          Out of Stock
        </button>
      </div>
    )}

    {/* Bank Finance Section */}
    <div className="bank-finance">
      <h3 className="finance-title">Bank Finance Available</h3>

      {/* Salaried Loan */}
      <div className="finance-option">
        <h4>Salaried Loan</h4>
        <div className="finance-table">
          <div className="finance-row">
            <span className="label">Deposit</span>
            <span className="value">15% of Price</span>
          </div>
          <div className="finance-row">
            <span className="label">Repayment Period</span>
            <span className="value">24 months</span>
          </div>
          <div className="finance-row">
            <span className="label">Interest Rate</span>
            <span className="value">20%</span>
          </div>
        </div>
      </div>

      {/* Business Loan */}
      <div className="finance-option">
        <h4>Business Loan</h4>
        <div className="finance-table">
          <div className="finance-row">
            <span className="label">Deposit</span>
            <span className="value">30% of Price</span>
          </div>
          <div className="finance-row">
            <span className="label">Repayment Period</span>
            <span className="value">24 months</span>
          </div>
          <div className="finance-row">
            <span className="label">Interest Rate</span>
            <span className="value">20%</span>
          </div>
        </div>
      </div>

      <div className="finance-btn-wrapper">
        <a href={`/loan-financing/${getProductSlug}`} className="finance-btn">
          Apply Now
        </a>
      </div>
    </div>
  </div>
)}             
            </div>
          </div>  

          
        <section className="col-12   product-description justify-content-between position-relative about-item mb-3 d-flex">
        
           <div className="d-column  desc-col-1  gap-15">
     
       
    

           <h3>Features</h3>  
           
            <div className="vehicle-specs-grid">
  {productSpecs.map((spec, index) => (
    <div className="spec-item" key={index}>
      <div className="spec-title">{spec.label}</div>
      <div className="spec-value">{spec.value}</div>
    </div>
  ))}
</div>
 

    
           
            {productState?.youtubeLink && (
           <div className="video-desc p-3 bg-white">
           <div className="ratio ratio-16x9">
    <iframe src={productState?.youtubeLink} title="YouTube video" allowFullScreen></iframe>
  </div>
           </div>
           )}


 

   

           </div>
         


      
         
         
          </section>
          </div>
{isDesktop && (
  <div className="vehicle__info-right-col">
    {productState?.stock !== "Out of Stock" ? (
      <>
        <SalesPersonCard />
      </>
    ) : (
      <div className="stock-container">
        <button className="button border-0 out-of-stock-btn" disabled>
          Out of Stock
        </button>
      </div>
    )}

    {/* Enquiry Form 
    <div className="enquiry-container">
      <h3>Enquire About This Vehicle</h3>
      <form onSubmit={handleEnquirySubmit}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input type="text" id="name" name="name" required />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" required />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone Number</label>
          <input type="tel" id="phone" name="phone" required />
        </div>

        <div className="form-group">
          <label>Preferred Contact</label>
          <div className="contact-options">
            <label>
              <input type="radio" name="contactMethod" value="whatsapp" defaultChecked /> WhatsApp
            </label>
            <label>
              <input type="radio" name="contactMethod" value="email" /> Email
            </label>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="additionalInfo">Additional Info</label>
          <textarea id="additionalInfo" name="additionalInfo" rows="3"></textarea>
        </div>

        <button type="submit" className="submit-btn">Submit</button>
      </form>
    </div>*/}
    {/* Bank Finance Section */}
    <div className="bank-finance">
      <h3 className="finance-title">Bank Finance Available</h3>

      {/* Salaried Loan */}
      <div className="finance-option">
        <h4>Salaried Loan</h4>
        <div className="finance-table">
          <div className="finance-row">
            <span className="label">Deposit</span>
            <span className="value">15% of Price</span>
          </div>
          <div className="finance-row">
            <span className="label">Repayment Period</span>
            <span className="value">60 months</span>
          </div>
          <div className="finance-row">
            <span className="label">Interest Rate</span>
            <span className="value">18.7%</span>
          </div>
        </div>
      </div>

      {/* Business Loan */}
      <div className="finance-option">
        <h4>Business Loan</h4>
        <div className="finance-table">
          <div className="finance-row">
            <span className="label">Deposit</span>
            <span className="value">20% of Price</span>
          </div>
          <div className="finance-row">
            <span className="label">Repayment Period</span>
            <span className="value">48 months</span>
          </div>
          <div className="finance-row">
            <span className="label">Interest Rate</span>
            <span className="value">23.7%</span>
          </div>
        </div>
      </div>

      <div className="finance-btn-wrapper">
        <a href={`/loan-financing/${getProductSlug}`} className="finance-btn">
          Apply Now
        </a>
      </div>
    </div>
  </div>
)}



         </div>


      


 


               <section id="related-products" className=" recently-viewed-container  justify-content-center d-flex w-100 flex-column  align-items-center">
      {
        isDesktop  ? (
          <div className="w-100 mb-3 other-products-container">
        
          <RelatedProducts/>

          </div>

        ):(
          <div className="w-100 other-products-container">
        

          <div>
          {relatedProducts.length > 0 && (
        <div className='w-100 d-flex justify-content-start'>
          <h2 className="related-products-heading">You may also like</h2>
        </div>
      )}
          <RelatedProducts2/>
          </div>



          </div>

        )
      }


      </section>         
      </section>
      
 
      </div>
      </div>
     </Container>
    </>
  );
  
};

export default SingleProduct;